import { render, staticRenderFns } from "./TimelineItem.vue?vue&type=template&id=3c8040fa&scoped=true"
import script from "./TimelineItem.vue?vue&type=script&lang=js"
export * from "./TimelineItem.vue?vue&type=script&lang=js"
import style0 from "./TimelineItem.vue?vue&type=style&index=0&id=3c8040fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8040fa",
  null
  
)

export default component.exports